import ShellViewState from './ShellViewState';
import ShellViewProps from './ShellViewProps';
import { ContentViewModel } from '@levelapp/softfabric';

export default class ShellViewModel extends ContentViewModel<ShellViewState, ShellViewProps>{ }